<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

onMounted(async () => {
  // Try to restore auth from refresh token
  await authStore.refresh();
});
</script>

<template>
  <router-view />
</template>
